import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Dialog, DialogContent, Stack, Typography } from '@mui/material';

import LayoutBody from './LayoutBody';
import TemplateBody from './TemplateBody';

type Props = {
  close: () => void;
  open: boolean;
};
export default function ChooseTemplateDialog({ close, open }: Props) {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const renderTitle = () => {
    switch (type) {
      case 'LAYOUT':
        return (
          <>
            <Typography variant="h4" gutterBottom>
              Create a layout
            </Typography>
            <Typography color="text.secondary">
              Layouts allow your team to share content blocks and styles across templates. Start from scratch or quickly
              get started with one of our sample layouts.
            </Typography>
          </>
        );
      default:
        return (
          <>
            <Typography variant="h4">Create a template</Typography>
          </>
        );
    }
  };

  const renderBody = () => {
    switch (type) {
      case 'LAYOUT':
        return <LayoutBody close={close} />;
      default:
        return <TemplateBody close={close} />;
    }
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="lg">
      <Stack sx={{ p: 3, pb: 1 }}>{renderTitle()}</Stack>
      <DialogContent sx={{ height: '80vh' }}>{renderBody()}</DialogContent>
    </Dialog>
  );
}
